import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";
import { Button } from "./ui/button";

const ThemeToggle = ({ variant = "icon", className = "" }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  if (variant === "icon") {
    return (
      <button
        onClick={toggleTheme}
        className={`p-2 rounded-lg transition-colors ${
          isDark 
            ? "text-white/70 hover:text-white hover:bg-white/10" 
            : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
        } ${className}`}
        data-testid="theme-toggle-btn"
        aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      >
        {isDark ? (
          <Sun className="w-5 h-5" />
        ) : (
          <Moon className="w-5 h-5" />
        )}
      </button>
    );
  }

  if (variant === "switch") {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <Sun className={`w-4 h-4 ${isDark ? "text-white/40" : "text-yellow-500"}`} />
        <button
          onClick={toggleTheme}
          className={`relative w-12 h-6 rounded-full transition-colors ${
            isDark ? "bg-[#0046BE]" : "bg-gray-300"
          }`}
          data-testid="theme-toggle-switch"
        >
          <div
            className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-transform ${
              isDark ? "translate-x-7" : "translate-x-1"
            }`}
          />
        </button>
        <Moon className={`w-4 h-4 ${isDark ? "text-[#FFCC00]" : "text-gray-400"}`} />
      </div>
    );
  }

  // Button variant
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleTheme}
      className={`gap-2 ${
        isDark 
          ? "border-white/20 text-white hover:bg-white/10" 
          : "border-gray-300 text-gray-700 hover:bg-gray-100"
      } ${className}`}
      data-testid="theme-toggle-button"
    >
      {isDark ? (
        <>
          <Sun className="w-4 h-4" />
          Light Mode
        </>
      ) : (
        <>
          <Moon className="w-4 h-4" />
          Dark Mode
        </>
      )}
    </Button>
  );
};

export default ThemeToggle;
